import { openReviewer } from '@/api/open'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { DECISION_STATUS } from '@/utils/dict'
import { mapGetters } from 'vuex'
import customerReviewQuestion from '@/components/question.vue'
import CreatePNG from '@/components/createPNG.dialog.vue'
import manuscript from '@/api/manuscript'

export default {
  components: { customerReviewQuestion, CreatePNG },
  data() {
    return {
      showEditor: true,
      showAuthor: true,
      // isEditor: false,
      isView: true,
      responseData: [],
      decisionStatus: DECISION_STATUS,
      showReport: true,
      showResponse: true,
      code: '',
      pdfType: 'rc-c',
      isVisablePDF: false,
      inputData: {},
      journalInfo: {}
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      title: 'getTitle',
      domain: 'getDomain'
    })
  },
  mounted() {
    this.code = this.$route.query.reviewskey
    this.getData()
  },
  methods: {
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(this.responseData.fileList, 'author_files.zip')
      }
    },
    async getData() {
      const journal = await openReviewer.reviewsCode(this.code)
      this.journalInfo = journal
      const result = await openReviewer.reviewReport(this.code)
      this.responseData = result
    },
    back() {
      this.$router.back(-1)
    },
    togalReport(item, type) {
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.responseData = JSON.parse(JSON.stringify(this.responseData))
    },
    // 生成证书
    async createCanvans(type) {
      // console.log(this.responseData, 'll', this.journalInfo)
      const res = await openReviewer.certificate(this.code)
      this.inputData = res
      this.pdfType = type
      this.isVisablePDF = true
    },
    cancel() {
      this.isVisablePDF = false
    }
  }
}
